enum TaskActivityViewType {
    all = 0,
    mine = 1,
    following = 2,
    todo = 3,
    unread = 3,
    participantsForm = 4,
    moderatorForm = 5,
    heatmap = 6
}

export default TaskActivityViewType;